import {Table, Form, Space, Radio, Badge, Flex, InputNumber, DatePicker, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import IncomeCheck from './IncomeCheck';
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './income.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import ClientSelect from '../../system/client/ClientSelect';
import dayjs from 'dayjs';
import UserSelect from '../../system/user/UserSelect';
function IncomeListAll(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "ddsr_state": '',     
      "ddsr_id": '',
  });
    useEffect(() => {
        if (props.list) {
            let arr = props.list.slice();
            if(query.ddsr_state){
              arr = arr.filter((item) => item.ddsr_state === query.ddsr_state);
            }      
            if(query.ddsr_amount){
              arr = arr.filter((item) => Number(item.ddsr_amount) === Number(query.ddsr_amount));
            }
            if(query.ddsr_kh_id){
              arr = arr.filter((item) => Number(item.ddsr_kh_id) === Number(query.ddsr_kh_id));
            }
            if(query.ddsr_date){
              arr = arr.filter((item) => dayjs(item.ddsr_date).format('YYYY-MM-DD') === query.ddsr_date);
            }
            if(query.ddsr_uid){
              arr = arr.filter((item) => item.ddsr_uid === query.ddsr_uid);
            }
            if(query.ddsr_id){
              arr = arr.filter((item) => item.key === query.ddsr_id);
            }
            arr = arr.map((item) => ({
                ...item,
                key: item.key || item.ddsr_id
            }));
            arr.sort((a, b) => new Date(b.ddsr_ctime) - new Date(a.ddsr_ctime));
            setList(arr);
        }
    }, [props.list, props.yh_id,query])
    
    const columns = [    
        {
            title: '收款客户',
            dataIndex: 'ddsr_kh_name',
            width: '12%',
            key: 'ddsr_kh_name',         
            render: (text, record) =><IncomeCheck
                                        type='button'
                                        ddsr_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        ddsr_bzd_id={record.ddsr_bzd_id}
                                        ddsr_price={record.ddsr_price}
                                        ddsr_content={record.ddsr_content}
                                        ddsr_date={record.ddsr_date}
                                        ddsr_date_end={record.ddsr_date_end}
                                        ddsr_bzd_name={record.ddsr_bzd_name}
                                        ddsr_bzd_danhao={record.ddsr_bzd_danhao}
                                        ddsr_type_id={record.ddsr_type_id}
                                        ddsr_type_name={record.ddsr_type_name}
                                        ddsr_kh_id={record.ddsr_kh_id}
                                        ddsr_kh_name={record.ddsr_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        ddsr_num={record.ddsr_num}
                                        ddsr_amount={record.ddsr_amount}
                                        ddsr_state={record.ddsr_state}
                                        ddsr_bm_id={record.ddsr_bm_id}
                                        ddsr_bm_name={record.ddsr_bm_name}
                                        ddsr_khyhzh_id={record.ddsr_khyhzh_id}
                                        ddsr_khyhzh_name={record.ddsr_khyhzh_name}
                                        ddsr_image_name={record.ddsr_image_name}
                                        ddsr_image_file={record.ddsr_image_file}
                                        ddsr_ctime={record.ddsr_ctime}
                                        ddsr_uid={record.ddsr_uid}
                                        yh_qx={props.yh_qx}
                                    />
        },
        {
            title: '收款金额',
            dataIndex: 'ddsr_amount',
            width: '10%',
            key: 'ddsr_amount',   
            render: (text, record) => <span style={{color:'red'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '收款事由',
            dataIndex: 'ddsr_name',
            key:'ddsr_name',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"ddsr_bzd_danhao",
            key:'ddsr_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  dsbzd_name={record.ddsr_bzd_name} dsbzd_id={record.ddsr_bzd_id} dsbzd_danhao={record.ddsr_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            }
        },  
        {
            title: '提交记录',
            dataIndex: 'ddsr_ctime',
            key:'ddsr_ctime',
            render:(text,record) => {
                return <span>{record.ddsr_uname} {record.ddsr_ctime}</span>
            }
        },    
        {
            title: '状态',
            dataIndex: 'ddsr_state',
            width: '5%',
            key: 'ddsr_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_income_list_all'
                    form={form}
                    initialValues={{                        
                        ddsr_state: query.ddsr_state ? query.ddsr_state : '',                        
                        ddsr_uid: query.ddsr_uid ? query.ddsr_uid : '',
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            ddsr_state: values.ddsr_state ? values.ddsr_state : '',
                            ddsr_uid: values.ddsr_uid ? values.ddsr_uid : '',
                            ddsr_id: values.ddsr_id ? values.ddsr_id : '',
                        };
                        setQuery(prev => ({ ...prev, ...serializedValues }));
                        localStorage.setItem('jtg-caiwu_incomeList_ddsr_state', JSON.stringify(serializedValues.ddsr_state));
                        localStorage.setItem('jtg-caiwu_incomeList_ddsr_uid', JSON.stringify(serializedValues.ddsr_uid));
                        localStorage.setItem('jtg-caiwu_incomeList_ddsr_id', JSON.stringify(serializedValues.ddsr_id));
                    }}
                >
                    <Form.Item 
                        name='dsbzd_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle

                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    ddsr_state: e.target.value,                                     
                                }));
                                localStorage.setItem('jtg-caiwu_incomeList_ddsr_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge>
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Radio value='5' >已结束（未读）</Radio>
                            <Radio value='6' >已结束（已读）</Radio>
                        </Radio.Group>        
                    </Form.Item>    
                    <Form.Item name='ddsr_amount' wrapperCol={{ offset: 2 }}>
                        <InputNumber
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, ddsr_amount: value }));
                            }}
                            value={query.ddsr_amount ? query.ddsr_amount : undefined}
                            placeholder='收款单金额'
                            name='ddsr_amount'
                            style={{ width: '120px' }}
                        />
                    </Form.Item> 
                    <ClientSelect                       
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, ddsr_kh_id: '' })) }}
                        placeholder='收款单客户'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='ddsr_kh_id'
                        onChange={(khId) => { setQuery(prev => ({ ...prev, ddsr_kh_id: khId || '' })) }}
                        yh_id={props.yh_id}
                        list={props.commonList?.kf_data || props.commonList?.kh_data || []}
                        wrapperCol={{ span: 18 }}
                    />  
                    <Form.Item name='ddsr_date'>
                        <DatePicker 
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, ddsr_date: dayjs(value).format('YYYY-MM-DD') }));
                            }}
                            value={query.ddsr_date ? dayjs(query.ddsr_date) : null}
                            allowClear={true}
                            placeholder='收款单日期'
                            name='ddsr_date'
                        />
                    </Form.Item>          
                    <UserSelect
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, ddsr_uid: '' })) }}
                        placeholder='操作员'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='ddsr_uid'
                        onChange={(e) => {setQuery(prev => ({ ...prev, ddsr_uid: e.yh_id || '' }))}}
                    />
                    <Form.Item name='ddsr_id' >
                        <Input placeholder='收款单编号' onChange={(e) => {setQuery(prev => ({ ...prev, ddsr_id: e.target.value || '' }))}} style={{ width: "100px" }} />
                    </Form.Item>
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_incomeList_ddsr_state', JSON.stringify(''))
                                    setQuery({
                                        "ddsr_state": '',
                                        ddsr_kh_id: '',
                                        ddsr_amount: undefined,
                                        ddsr_uid: '',
                                        ddsr_date: '',
                                        ddsr_id: '',
                                    })
                                    form.setFieldsValue({
                                        ddsr_name: null,
                                        ddsr_kh_id: null,
                                        ddsr_bzd_danhao: null,
                                        ddsr_uid: null,
                                        ddsr_date: null,
                                        ddsr_id: '',
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>  
            </Flex>
            <Table 
                className={classes.pinkHeader}
                dataSource={list}
                columns={columns}
                pagination={{
                    pageSize: 50,
                    pageSizeOptions: [10, 20, 50, 100],
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `共 ${total} 条`,
                    onChange: (page, pageSize) => {
                        console.log(page, pageSize);
                    }
                }}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1} colSpan={1}>
                                <span style={{color:'red'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无收款数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default IncomeListAll